/** What the generated content draws a grow as: a lorem `book` — page 1 its
 * cover, a flap a cover's —, a `depliant` — posters across its panels, a
 * folder, a fold, a sheet —, a `box` — a product's face, text on its
 * walls —, or a notepad — a book's cover round pages ruled
 * blank, lined 10.25 or 8 mm apart, squared 5 or 10 mm, dotted or millimetre
 * paper —, or a calendar — a month a page after its cover, a picture over
 * each month, or the whole year on a page, for any size or as one of the
 * shop's designs lays it out. */
export const enum ContentRenderer {
  BOOK = "book",
  BOX = "box",
  DEPLIANT = "depliant",
  NOTEPAD_BLANK = "notepad_blank",
  NOTEPAD_LINED = "notepad_lined",
  NOTEPAD_SQUARED = "notepad_squared",
  NOTEPAD_DOTTED = "notepad_dotted",
  NOTEPAD_LINED_8 = "notepad_lined_8",
  NOTEPAD_SQUARED_10 = "notepad_squared_10",
  NOTEPAD_MILLIMETER = "notepad_millimeter",
  CALENDAR_MONTH = "calendar_month",
  CALENDAR_SPREAD = "calendar_spread",
  CALENDAR_YEAR = "calendar_year",
  CALENDAR_AKINDEZ = "calendar_akindez",
  CALENDAR_AKURA = "calendar_akura",
  CALENDAR_BELWE = "calendar_belwe",
  CALENDAR_CLAN = "calendar_clan",
  CALENDAR_DASH = "calendar_dash",
  CALENDAR_DUBIEL = "calendar_dubiel",
  CALENDAR_EAVES = "calendar_eaves",
  CALENDAR_HAMURZ = "calendar_hamurz",
  CALENDAR_HOOGE = "calendar_hooge",
  CALENDAR_INTERSTATE = "calendar_interstate",
  CALENDAR_KAUSHAN = "calendar_kaushan",
  CALENDAR_KEBBY = "calendar_kebby",
  CALENDAR_LATO = "calendar_lato",
  CALENDAR_MADISON = "calendar_madison",
  CALENDAR_MILO = "calendar_milo",
  CALENDAR_NELSON = "calendar_nelson",
  CALENDAR_RALEWAY = "calendar_raleway",
  CALENDAR_ROBOTO = "calendar_roboto",
  CALENDAR_RODDENBERRY = "calendar_roddenberry",
  CALENDAR_STYMIE = "calendar_stymie",
  CALENDAR_TRIXIE = "calendar_trixie",
  CALENDAR_VINNIE = "calendar_vinnie",
  CALENDAR_WONDERWALL = "calendar_wonderwall",
  AGENDA_WEEKLY = "agenda_weekly",
  AGENDA_DAILY = "agenda_daily",
  AGENDA_ALTAIR = "agenda_altair",
  AGENDA_KIONA = "agenda_kiona",
  AGENDA_KIONA_DAILY = "agenda_kiona_daily",
  AGENDA_LEIXO = "agenda_leixo",
  AGENDA_MUNA = "agenda_muna",
  AGENDA_PAPYRUS = "agenda_papyrus",
  AGENDA_PERPETUAL = "agenda_perpetual",
  AGENDA_PERPETUAL_DAILY = "agenda_perpetual_daily",
  PLANNER_WEEKLY = "planner_weekly",
  PLANNER_PERPETUAL = "planner_perpetual",
  PLANNER_ALBERTUS = "planner_albertus",
  PLANNER_LEXICON = "planner_lexicon",
  PLANNER_LUBALIN = "planner_lubalin",
  COUNTERFOIL = "counterfoil",
}
